export default __webpack_public_path__ + "static/media/EnhancedCrossIcon.fb74d5e5.svg";